/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendFeedback200Response
 */
export interface SendFeedback200Response {
    /**
     * 
     * @type {boolean}
     * @memberof SendFeedback200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendFeedback200Response
     */
    error: string;
    /**
     * 
     * @type {object}
     * @memberof SendFeedback200Response
     */
    data: object;
}

/**
 * Check if a given object implements the SendFeedback200Response interface.
 */
export function instanceOfSendFeedback200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function SendFeedback200ResponseFromJSON(json: any): SendFeedback200Response {
    return SendFeedback200ResponseFromJSONTyped(json, false);
}

export function SendFeedback200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendFeedback200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': json['data'],
    };
}

export function SendFeedback200ResponseToJSON(value?: SendFeedback200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': value.data,
    };
}

